var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google",
    clipPath: "url(#clip0_186_730)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.25 10H12V14.25H17.9C17.35 16.95 15.05 18.5 12 18.5C8.4 18.5 5.5 15.6 5.5 12C5.5 8.4 8.4 5.5 12 5.5C13.55 5.5 14.95 6.05 16.05 6.95L19.25 3.75C17.3 2.05 14.8 1 12 1C5.9 1 1 5.9 1 12C1 18.1 5.9 23 12 23C17.5 23 22.5 19 22.5 12C22.5 11.35 22.4 10.65 22.25 10Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 10V14.25H17.9C17.35 16.95 15.05 18.5 12 18.5C9.10002 18.5 6.70002 16.65 5.85002 14.05L2.15002 16.9C3.90002 20.5 7.65002 23 12 23C17.5 23 22.5 19 22.5 12C22.5 11.35 22.4 10.65 22.25 10H12Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.5 12C5.5 11.3 5.6 10.6 5.85 9.94998L2.15 7.09998C1.4 8.59998 1 10.25 1 12C1 13.75 1.4 15.4 2.15 16.85L5.85 14C5.6 13.4 5.5 12.7 5.5 12Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.15002 7.15L5.85002 10C6.70002 7.35 9.10002 5.5 12 5.5C13.55 5.5 14.95 6.05 16.05 6.95L19.25 3.75C17.3 2.05 14.8 1 12 1C7.65002 1 3.90002 3.5 2.15002 7.15Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12 10V14.25H17.9C17.6 15.7 16.8 16.8 15.65 17.55L19.15 20.25C21.15 18.35 22.5 15.6 22.5 12C22.5 11.35 22.4 10.65 22.25 10H12Z",
    fill: "#4285F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.aafaf415c45d8304888f68f3915d77f1.svg";
export { ForwardRef as ReactComponent };